export default "__VITE_ASSET__BRzpXo8T__"